@layer module {
.section-card__head {
            display: flex;
            align-items: flex-start;
    }

.section-card__titles {
            flex: 1 1 auto;
            min-width: 0;
    }

.section-card__icon {
            display: grid;
            flex-shrink: 0;
            place-items: center;
            border-radius: 50%;
    }

.section-card__title {
            display: flex;
            align-items: center;
    }

.section-card__aside {
            display: flex;
            flex-shrink: 0;
            align-items: center;
    }
} // layer module










@layer app {
.section-card__head {
            gap: $size-12;
    }

.section-card__icon {
            width: $size-38;
            height: $size-38;
    }

.section-card__title {
            gap: $size-10;
            margin: 0;
    }

.section-card__description {
            margin: $size-2 0 0;
    }

.section-card__aside {
            gap: $size-10;
    }

.section-card__icon {
            background: var(--color-brand-wash);
            color: var(--color-brand);
    }

.section-card__title {
            color: var(--text-primary);
            font-size: var(--font-size-lg);
            font-weight: 600;
    }

.section-card__description {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
    }
} // layer app
